module.exports = "/assets/data/8562701aae2f70d2a134836a63342720-DD11.data.json";